import { render, staticRenderFns } from "./AddCourse.vue?vue&type=template&id=6d4ca1bb&scoped=true&"
import script from "./AddCourse.vue?vue&type=script&lang=js&"
export * from "./AddCourse.vue?vue&type=script&lang=js&"
import style0 from "./AddCourse.vue?vue&type=style&index=0&id=6d4ca1bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4ca1bb",
  null
  
)

export default component.exports